import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const MobileIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3 5.8501H21V7.8661H3V5.8501ZM3 12.8341V10.8661H21V12.8341H3ZM3 17.8501V15.8341H21V17.8501H3Z'
                fill='currentColor'
            />
        </>
    ),
})

MobileIcon.displayName = 'MobileIcon'
